var map = {
	"./amazon.svg": 7114,
	"./appleappstore.svg": 0,
	"./facebook.svg": 386,
	"./g2.svg": 5981,
	"./gartner.svg": 3900,
	"./glassdoor.svg": 242,
	"./google.svg": 1790,
	"./googleplaystore.svg": 4782,
	"./kununu.svg": 8823,
	"./p.svg": 6932,
	"./provenexpert.svg": 4409,
	"./reviewforest.svg": 6115,
	"./t.svg": 8783,
	"./trustedshops.svg": 1926,
	"./trustpilot.svg": 4414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7053;